var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCollectionBottomChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9998_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14722 1.6063L6.14676 1.6059C4.9217 0.531595 2.94198 0.530989 1.72411 1.60635C0.49135 2.69486 0.492914 4.48979 1.72309 5.59101L1.72411 5.59191L25.2805 26.3919C25.8794 26.9207 26.668 27.2 27.5 27.2C28.3321 27.2 29.1206 26.9207 29.7195 26.3919L53.2759 5.59192L53.2774 5.59056C54.5066 4.48273 54.5089 2.69513 53.2759 1.60634L53.2744 1.60501C52.0344 0.532335 50.0553 0.530542 48.837 1.60635L27.5 20.4466L6.14722 1.6063Z",
    fill: "#535355",
    stroke: "#535355",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9998_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 55,
    fill: "white",
    transform: "matrix(0 1 -1 0 55 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCollectionBottomChevron);
export default __webpack_public_path__ + "static/media/edit-collection-bottom-chevron.2185501ff695f13475172797dcc119e6.svg";
export { ForwardRef as ReactComponent };